export const CONNECT_SOCKET = 'CONNECT_SOCKET';
// export const SUBSCRIBE_USER = 'SUBSCRIBE_USER';

export const connectSocket = socketIO => ({
    type: CONNECT_SOCKET,
    payload: socketIO,
});

// export const subscribeUser = user => ({
//     type: SUBSCRIBE_USER,
//     payload: user,
// });
